import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Images from "../asset";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Loading from "./Loading";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from "react-select";
import Dropdown from "react-multilevel-dropdown";
import moment from "moment/moment";
import Alert from "./Alert";
const VisitorListCom = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [dltId, setDltId] = useState();
  const [postAlert, setPostAlert] = useState();
  const [putAlert, setPutAlert] = useState();
  const [sortOrder, setSortOrder] = useState(null);
  const [filteredItem, setFilteredItem] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [dobSortOrder, setDobSortOrder] = useState(null);
  // const ageSet = ["10/20","20/30"]
  const categories = [
    // { value: "name", label: "Name" },
    { value: "age", label: "Age" },
    { value: "caste", label: "Caste" },
    { value: "religion", label: "Religion" },
    { value: "category", label: "Category" },
    { value: "gender", label: "Gender" },
  ];

  const userData = sessionStorage.getItem("userdata");
  // console.log("userData", userData);

  const visitorData = async () => {
    return await axios.get(`${process.env.REACT_APP_HOST}/newvisitors`);
  };

  const { data, isLoading, isError, refetch } = useQuery(
    "visitorData",
    visitorData
  );
  const deleteUser = async (id) => {
    return await axios.delete(
      `${process.env.REACT_APP_HOST}/newvisitors/${id}`
    );
  };

  // // Delete multiple users
  const deleteUsers = async (ids) => {
    return await Promise?.all(
      ids?.map((id) => {
        return deleteUser(id);
      })
    );
  };
  let details = (data && data?.data) || [];

  const handleCheckboxChange = (id) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows?.includes(id);
      if (isSelected) {
        return prevSelectedRows?.filter((rowId) => rowId !== id);
      } else {
        return [...prevSelectedRows, id];
      }
    });
  };

  const mutation = useMutation({
    mutationFn: deleteUsers,
    onSuccess: () => {
      refetch();
      setPutAlert(false);
      setSelectedRows([]); // Clear selected rows
    },
    onError: (error) => {
      // console.error("Error deleting rows:", error);
      alert("Error deleting rows");
    },
  });
  const handleDelete = (id) => {
    setDltId(id);
    setPostAlert(true);
    // setPostAlert(false);
    setPutAlert(false);
  };
  useEffect(() => {
    if (selectedRows?.length !== 0 && putAlert) {
      mutation.mutate(selectedRows);
    } else if (putAlert && dltId) {
      deleteUser(dltId)
        .then(() => {
          refetch();
          setPostAlert(false);
          setPutAlert(false);
          setDltId(null);
        })
        .catch((error) => {
          alert("Error deleting row");
        });
    }
  }, [selectedRows, putAlert, dltId]);

  // Filter details based on search term

  const filteredDetails = searchTerm
    ? details &&
      details?.filter((visitor) => {
        const term = searchTerm?.toLowerCase();
        return (
          // (visitor && visitor?.fileNumber?.toString().startsWith(term)) ||
          (visitor && visitor?.name?.toLowerCase().startsWith(term)) ||
          (visitor && visitor?.age?.toString().startsWith(term)) ||
          (visitor && visitor?.mobileNumber?.toString().startsWith(term)) ||
          (visitor && visitor?.email?.toLowerCase().startsWith(term)) ||
          (visitor &&
            visitor?.permanentAddress?.toLowerCase().includes(term)) ||
          (visitor && visitor?.education?.toLowerCase().includes(term)) ||
          (visitor && visitor?.category?.toLowerCase().includes(term)) ||
          (visitor && visitor?.officeAddress?.toLowerCase().includes(term))
          // (visitor && visitor?.dob?.toString().toLowerCase().startsWith(term))
        );
      })
    : details;

  // Helper function to generate age range options
  const generateAgeOptions = () => {
    const ageRanges = [
      "0/18",
      "18/30",
      "30/40",
      "40/50",
      "50/60",
      "60/70",
      "70/80",
      "80/90",
      "90/99",
    ];

    return (
      ageRanges &&
      ageRanges?.map((range) => ({
        label: `${range}`,
        value: range,
      }))
    );
  };

  const generateOptions = (category) => {
    if (!category) return []; // Return empty if no category selected

    if (category === "age") {
      return generateAgeOptions(); // Return age options if category is "age"
    }

    const uniqueValues = [
      ...new Set(
        filteredDetails && filteredDetails?.map((item) => item[category])
      ),
    ];

    return (
      uniqueValues &&
      uniqueValues?.map((value) => ({
        label: value,
        value,
      }))
    );
  };
  // Handle item selection and removal
  const handleItemSelection = (selectedOption) => {
    setSelectedItems((prevItems) => {
      const isAlreadySelected =
        prevItems &&
        prevItems?.some(
          (item) =>
            item?.value === selectedOption?.value &&
            item?.label === selectedOption?.label
        );
      if (isAlreadySelected) {
        return (
          prevItems &&
          prevItems?.filter(
            (item) =>
              item?.value !== selectedOption?.value ||
              item?.label !== selectedOption?.label
          )
        ); // Remove item
      } else {
        return [...prevItems, selectedOption]; // Add item
      }
    });
  };
  // Handle category selection
  const handleCategorySelect = (categoryItem) => {
    console.log("Selected Category:", categoryItem); // Debugging log
  };
  // Handle value selection for category
  const handleValueSelect = (category, option) => {
    console.log("Selected Value:", option); // Debugging log
    setSelectedValues((prevValues) => ({
      ...prevValues,
      [category]: option?.value, // Update the selected value for the specific category
    }));
    handleItemSelection(option); // Add item to selected items
  };

  // Handle removal of selected item
  const handleRemoveItem = (item) => {
    setSelectedItems(
      (prevItems) =>
        prevItems &&
        prevItems?.filter(
          (i) => i?.value !== item?.value || i?.label !== item?.label
        )
    );

    setSelectedValues((prevValues) => {
      const updatedValues = { ...prevValues };
      const category = Object.keys(prevValues).find(
        (key) => prevValues[key] === item?.label
      );
      if (category) {
        delete updatedValues[category];
      }
      return updatedValues;
    });
  };
  // Filtering the data based on selected filters
  const filteredData =
    filteredDetails &&
    filteredDetails?.filter((row) => {
      return Object.keys(selectedValues)?.every((category) => {
        if (selectedValues[category]) {
          // Check if the selected category is "age"
          if (category === "age" && selectedValues[category]) {
            const ageRange = selectedValues[category]; // Get the selected age range
            const [minAge, maxAge] = ageRange.split("/").map(Number); // Split and convert to numbers
            const age = Number(row[category]); // Get the age from the row data

            // Check if the row's age is within the selected range
            return age >= minAge && age <= maxAge;
          }

          // Default filtering for other categories
          return row[category] === selectedValues[category];
        }
        return true;
      });
    });

  // console.log("filter data", filteredData);
  // download excel
  const downloadExcel = () => {
    // Determine data to export based on filter
    const exportData =
      filteredData && filteredData?.length > 0 ? filteredData : filteredData;

    // Prepare data for the table worksheet
    const tableDatas =
      exportData && exportData?.length > 0
        ? exportData?.map((data, index) => ({
            "S.NO": index + 1,
            "DATE OF VISIT": data?.dateOfVisit
              ? moment(data?.dateOfVisit).format("YYYY-MM-DD")
              : null,
            "INTIME/OUTTIME": `${data?.inTime || null}/${
              data?.outTime || null
            }`,
            "NAME/AGE/GENDER": `${data?.name || null}/${data?.age || null}/${
              data?.gender || null
            }`,
            "S/O": data?.fatherName || null,
            "DATE OF BIRTH": data?.dob
              ? moment(data?.dob).format("YYYY-MM-DD")
              : null,
            "RELIGION/CASTE": `${data?.religion || null}/${
              data?.caste || null
            }`,
            "MOBILE NUMBER/ALTERNATIVE NUMBER": `${
              data?.mobileNumber || null
            }/${data?.alternativeNumber || null}`,
            "WHATSAPP NUMBER": data?.whatsapp || null,
            "EMAIL ID": data?.email || "",
            CATEGORY: data?.category || "",
            REFERENCE: data?.sourceForm || null,
            "PURPOSE OF VISIT": data?.purposeOfVisit || null,
            // "PLACE OF RESIDANCE": data?.placeOfResidence || "",
            ADDRESS: data?.permanentAddress || "",
            // "COUNTRY, STATE, DISTRICT":
            //   `${data?.country} ${data?.state} ${data?.district}` || "",
            STATUS: data?.status || "",
          }))
        : []; // Default to an empty array

    // Create table worksheet with headers
    const tableWorksheet = XLSX.utils.json_to_sheet(
      tableDatas?.length > 0 ? tableDatas : [{}],
      {
        skipHeader: false, // Ensure the header is included
      }
    );

    // If tableDatas is empty, add headers manually
    if (tableDatas?.length === 0) {
      XLSX.utils.sheet_add_aoa(tableWorksheet, [
        [
          "S.NO",
          "DATE OF VISIT",
          "INTIME/OUTTIME",
          "NAME/AGE/GENDER",
          "S/O",
          "DATE OF BIRTH",
          "RELIGION/CASTE",
          "MOBILE NUMBER/ALTERNATIVE NUMBER",
          "WHATSAPP NUMBER",
          "EMAIL ID",
          "CATEGORY",
          "REFERENCE",
          "PURPOSE OF VISIT",
          "ADDRESS",
          "STATUS",
        ],
      ]);
    }

    // Create a new workbook and add the worksheets
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, tableWorksheet, "Table Data");

    // Generate the Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Save the Excel file
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Visitor Information.xlsx");
  };

  // Sort data based on sortOrder
  const sortedData = useMemo(() => {
    if (!filteredData) return [];

    let sorted = [...filteredData];

    sorted.sort((a, b) => {
      // Sort by name first if `sortOrder` is defined
      if (sortOrder === "atoz" || sortOrder === "ztoa") {
        const nameA = a.name ? a.name.toLowerCase() : "";
        const nameB = b.name ? b.name.toLowerCase() : "";
        const nameComparison = nameA.localeCompare(nameB);

        if (sortOrder === "atoz") return nameComparison;
        if (sortOrder === "ztoa") return -nameComparison;
        console.log("dobSortOrder", sortOrder);
      }

      // Then, sort by DOB if `dobSortOrder` is defined
      if (dobSortOrder === "dobAscending" || dobSortOrder === "dobDescending") {
        const dobComparison = new Date(a.dob) - new Date(b.dob);

        if (dobSortOrder === "dobAscending") return dobComparison;
        if (dobSortOrder === "dobDescending") return -dobComparison;
      }
      if (dobSortOrder === "dovAscending" || dobSortOrder === "dovDescending") {
        const dovComparison = new Date(a.dateOfVisit) - new Date(b.dateOfVisit);

        if (dobSortOrder === "dovAscending") return dovComparison;
        if (dobSortOrder === "dovDescending") return -dovComparison;
      }

      return 0; // No sorting applied
    });

    return sorted;
  }, [filteredData, sortOrder, dobSortOrder]);

  return (
    <>
      <div className="m-0 px-1 visitor-main-container">
        <div className="row">
          <div className="col-4 d-flex align-items-center gap-1 pb-2 pt-3">
            <div
              style={{ width: "50px", height: "40px", cursor: "pointer" }}
              onClick={() => navigate(-1)}
            >
              <img
                src={Images?.arrowBack}
                style={{ width: "100%", height: "100%" }}
                alt="back"
                title="back arrow"
              />
            </div>
            <h6 className="client-view-head pt-2">Visitor Information</h6>
          </div>
          <div className="col-8 d-flex align-items-center justify-content-end gap-2">
            <div className="search-block-client-view">
              <input
                type="search"
                className="table-search"
                value={searchTerm}
                placeholder="Search by  name, age, mobNo, emailid, place"
                title="Search by  name, age, mobNo, emailid, place"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <div className="image_icon">
                <img
                  src={Images?.searchIcon}
                  style={{ width: "100%", height: "100%" }}
                  alt="Search"
                />
              </div>
            </div>

            <Dropdown title="Filter">
              {categories &&
                categories?.map((categoryItem) => (
                  <Dropdown.Item
                    key={categoryItem?.value}
                    onClick={() => handleCategorySelect(categoryItem)}
                  >
                    {categoryItem?.label}
                    <Dropdown.Submenu>
                      {/* Display options for the selected category */}
                      {generateOptions(categoryItem?.value).map((option) => (
                        <Dropdown.Item
                          key={option?.value}
                          onClick={() =>
                            handleValueSelect(categoryItem?.value, option)
                          }
                        >
                          {option?.label}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Submenu>
                  </Dropdown.Item>
                ))}
            </Dropdown>
            <button
              className="--client-register new-register-btn"
              onClick={() => {
                downloadExcel();
              }}
            >
              Download
            </button>
            <button
              className="--client-register new-register-btn"
              onClick={() => {
                navigate("/visitorEntry");
              }}
            >
              New Visitor
            </button>
            {selectedRows == undefined || selectedRows?.length == 0 ? (
              <></>
            ) : (
              <>
                <button className="delete-btn" onClick={handleDelete}>
                  <img
                    style={{ height: "30px" }}
                    src={Images?.deleteIcon}
                    alt={"deleteIcon"}
                    // style={{ width: "100%", height: "100%" }}
                  />
                  {/* {mutation.isLoading ? "Deleting..." : "DELETE"} */}
                </button>
              </>
            )}
          </div>
        </div>
        <div
          className="row m-0 p-0 px-3"
          style={{
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          <div className="col-12 d-flex justify-content-end m-0 p-0">
            {selectedItems && selectedItems?.length > 0 ? (
              selectedItems?.map((item) => {
                return (
                  <>
                    <span
                      key={item?.value + item?.label}
                      style={{
                        // margin: "5px",
                        padding: "5px",
                        border: "1px solid #ccc",
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                    >
                      {item?.label}
                      <button
                        onClick={() => handleRemoveItem(item)} // Remove item when clicked
                        style={{
                          marginLeft: "5px",
                          background: "red",
                          color: "white",
                          border: "none",
                          padding: "0px 6px",
                          cursor: "pointer",
                        }}
                      >
                        X
                      </button>
                    </span>
                  </>
                );
              })
            ) : (
              <>
                <p className="m-0 p-0 filter-content">
                  No categories selected. Please choose a category to proceed
                </p>
              </>
            )}
          </div>
        </div>

        <div className="mb-1 register-table-block">
          <TableContainer className="product_table_container_sticky">
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className="product_table_heading_small">
                    S.No
                  </TableCell>
                  {userData == "admin" ? (
                    <></>
                  ) : (
                    <>
                      <TableCell className="product_table_heading_small">
                        Edit/Delete
                      </TableCell>
                    </>
                  )}
                  <TableCell className="product_table_heading_small">
                    Visitor's Count
                  </TableCell>
                  <TableCell className="product_table_heading">
                    Name
                    <div className="d-flex align-items-center gap-2">
                      <button
                        className="filter-button"
                        onClick={() => setSortOrder("atoz")}
                        style={{
                          fontSize: "5px",
                          textAlign: "center",
                        }}
                      >
                        <img
                          src={Images?.arrowdown}
                          alt="no-image"
                          style={{ width: "100%", height: "100%" }}
                        />
                      </button>
                      <button
                        className="filter-button"
                        onClick={() => setSortOrder("ztoa")}
                        style={{
                          fontSize: "5px",
                          textAlign: "center",
                        }}
                      >
                        <img
                          src={Images?.arrowup}
                          alt="no-images"
                          style={{ width: "100%", height: "100%" }}
                        />
                      </button>
                    </div>
                  </TableCell>
                  <TableCell className="product_table_heading">
                    Relation Title
                  </TableCell>
                  <TableCell className="product_table_heading_small">
                    Education
                  </TableCell>
                  <TableCell className="product_table_heading_small">
                    Age
                  </TableCell>
                  <TableCell className="product_table_heading_small">
                    Date of visit
                    <div className="d-flex align-items-center gap-2">
                      <button
                        className="filter-button"
                        onClick={() => {
                          setDobSortOrder("dovAscending");
                          setSortOrder(null);
                        }}
                        style={{
                          fontSize: "5px",
                          textAlign: "center",
                        }}
                      >
                        <img
                          src={Images?.arrowdown}
                          alt="no-image"
                          style={{ width: "100%", height: "100%" }}
                        />
                      </button>
                      <button
                        className="filter-button"
                        onClick={() => {
                          setDobSortOrder("dovDescending");
                          setSortOrder(null);
                        }}
                        style={{
                          fontSize: "5px",
                          textAlign: "center",
                        }}
                      >
                        <img
                          src={Images?.arrowup}
                          alt="no-images"
                          style={{ width: "100%", height: "100%" }}
                        />
                      </button>
                    </div>
                  </TableCell>

                  <TableCell className="product_table_heading_small">
                    DOB
                    <div className="d-flex align-items-center gap-2">
                      <button
                        className="filter-button"
                        onClick={() => {
                          setDobSortOrder("dobAscending");
                          setSortOrder(null);
                        }}
                        style={{
                          fontSize: "5px",
                          textAlign: "center",
                        }}
                      >
                        <img
                          src={Images?.arrowdown}
                          alt="no-image"
                          style={{ width: "100%", height: "100%" }}
                        />
                      </button>
                      <button
                        className="filter-button"
                        onClick={() => {
                          setDobSortOrder("dobDescending");
                          setSortOrder(null);
                        }}
                        style={{
                          fontSize: "5px",
                          textAlign: "center",
                        }}
                      >
                        <img
                          src={Images?.arrowup}
                          alt="no-images"
                          style={{ width: "100%", height: "100%" }}
                        />
                      </button>
                    </div>
                  </TableCell>
                  <TableCell className="product_table_heading_small">
                    Mob No
                  </TableCell>
                  <TableCell className="product_table_heading">
                    {/* Name of Parents/Guardian/Spouse/Children/Others & Contact No/ */}
                    Email Id
                  </TableCell>
                  <TableCell className="product_table_heading_small">
                    Religion
                  </TableCell>
                  <TableCell className="product_table_heading_small">
                    Caste
                  </TableCell>
                  <TableCell className="product_table_heading_small">
                    Category
                  </TableCell>
                  {/* <TableCell className="product_table_heading">
                    Place Of Residence
                  </TableCell> */}
                  <TableCell className="product_table_heading_small">
                    Present Address
                  </TableCell>
                  <TableCell className="product_table_heading_small">
                    Office Address
                  </TableCell>
                  {/* <TableCell className="product_table_heading">
                    State, Place
                  </TableCell> */}
                  <TableCell className="product_table_heading_small">
                    Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <Loading />
                ) : sortedData && sortedData?.length > 0 ? (
                  sortedData?.map((item, i) => (
                    <TableRow key={i}>
                      <TableCell className="product_table_data_small">
                        {i + 1}
                      </TableCell>
                      {userData == "admin" ? (
                        <></>
                      ) : (
                        <>
                          <TableCell className="product_table_data_small">
                            <div className="d-flex align-items-start justify-content-start gap-1">
                              <div className="d-flex align-items-center justify-content-center gap-2">
                                <input
                                  type="checkbox"
                                  checked={selectedRows?.includes(item?.id)}
                                  title="Select Row"
                                  onChange={() =>
                                    handleCheckboxChange(item?.id)
                                  }
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    cursor: "pointer",
                                  }}
                                />

                                <div
                                  style={{
                                    width: "25px",
                                    height: "30px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={Images?.pencilIcon}
                                    alt="edit-icon"
                                    style={{ width: "100%", height: "100%" }}
                                    title="Edit Row"
                                    onClick={() => {
                                      navigate("/visitorEntry", {
                                        state: item,
                                      });
                                    }}
                                  />
                                </div>
                                {/* <div
                                  style={{
                                    width: "27px",
                                    height: "27px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={Images?.deleteIcon}
                                    title="Delete Row"
                                    alt="edit-icon"
                                    style={{ width: "100%", height: "100%" }}
                                    onClick={() => handleDelete(item?.id)}
                                  />
                                </div> */}
                              </div>
                            </div>
                          </TableCell>
                        </>
                      )}

                      <TableCell
                        className="product_table_data_small"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        1 /{item && item?.duplicatevisitor?.length}
                        {console.log("item", item)}
                      </TableCell>
                      {/* <TableCell className="product_table_data">
                        {(item && item?.fileNumber) || "-"}
                      </TableCell> */}
                      <TableCell
                        className="product_table_data"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        {item && item?.name}
                      </TableCell>
                      <TableCell
                        className="product_table_data"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        {item && item?.surNameTitle}
                        {item && item?.surNameTitle ? " - " : ""}{" "}
                        {item && item?.fatherName}
                      </TableCell>
                      <TableCell
                        className="product_table_data_small"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        {item?.education}
                      </TableCell>
                      <TableCell
                        className="product_table_data_small"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        {item?.age}
                      </TableCell>
                      <TableCell
                        className="product_table_data_small"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        {/* {console.log("sortedData",item && item?.dateOfVisit)} */}
                        {moment((item && item?.dateOfVisit) || "-").format(
                          "YYYY-MM-DD"
                        )}
                      </TableCell>

                      <TableCell
                        className="product_table_data_small"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        {/* { || "-"} */}
                        {moment(item && item?.dob).format("YYYY-MM-DD") ===
                        "Invalid date"
                          ? "-"
                          : moment(item && item?.dob).format("YYYY-MM-DD")}
                      </TableCell>
                      <TableCell
                        className="product_table_data_small"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        {(item && item?.mobileNumber) || "-"}
                      </TableCell>
                      <TableCell
                        className="product_table_data"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        {(item && item?.email) || "-"}
                      </TableCell>
                      <TableCell
                        className="product_table_data_small"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        {item && item?.religion === "Other"
                          ? item?.otherReligion
                          : item?.religion}
                      </TableCell>
                      <TableCell
                        className="product_table_data_small"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        {/* {(item && item?.caste) || "-"} */}
                        {item && item?.caste === "Other"
                          ? item?.otherCaste
                          : item?.caste}
                      </TableCell>
                      <TableCell
                        className="product_table_data_small"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        {/* {(item && item?.category) || "-"} */}
                        {item && item?.category === "Other"
                          ? item?.otherCategory
                          : item?.category}
                      </TableCell>
                      {/* <TableCell className="product_table_data">
                        {(item && item?.placeOfResidence) || "-"}
                      </TableCell> */}
                      <TableCell
                        className="product_table_data"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        {(item && item?.temporaryAddress) || "-"}
                      </TableCell>
                      <TableCell
                        className="product_table_data"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        {(item && item?.officeAddress) || "-"}
                      </TableCell>

                      {/* <TableCell className="product_table_data">
                        {` ${item && item?.state} ${item?.district}` || "-"}
                      </TableCell> */}

                      <TableCell
                        className="product_table_data_small"
                        onClick={() => {
                          navigate("/visitorEntry", {
                            state: item,
                          });
                        }}
                      >
                        {(item && item?.status) || "-"}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={23}>No data available</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
      <Alert
        open={postAlert}
        setPutAlert={setPutAlert}
        // navigate = "/"
        // postAlert={postAlert}
        // putAlert={putAlert}
        add={false}
        onCloses={setPostAlert}
        // setPutAlert={setPutAlert}
      />
    </>
  );
};

export default VisitorListCom;
